import React, { useEffect, useState } from 'react';
const API_BASE = '/api/user/auth';

async function postJson(url: string, body: any) {
    const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || data.error || `Fehler (${res.status})`);
    return data;
}

export default function VerifyEmailPage() {
    const usp = new URLSearchParams(window.location.search);
    const email = usp.get('email') || '';
    const token = usp.get('token') || '';

    const [status, setStatus] = useState<'loading' | 'ok' | 'error'>('loading');
    const [msg, setMsg] = useState<string>('');
    const [seconds, setSeconds] = useState(3); // Countdown für Auto-Redirect

    useEffect(() => {
        (async () => {
            try {
                const data = await postJson(`${API_BASE}/verify-email`, { email, token });
                setMsg(data.message || 'E-Mail erfolgreich bestätigt.');
                setStatus('ok');
            } catch (e: any) {
                setMsg(e.message || 'Verifizierung fehlgeschlagen.');
                setStatus('error');
            }
        })();
    }, [email, token]);

    // Auto-Redirect, sobald status === 'ok'
    useEffect(() => {
        if (status !== 'ok') return;

        const tick = setInterval(() => {
            setSeconds(s => (s > 0 ? s - 1 : 0));
        }, 1000);

        const to = setTimeout(() => {
            // sofortige Weiterleitung; replace vermeidet Back zur Verify-Seite
            window.location.replace('/');
        }, 3000);

        return () => {
            clearInterval(tick);
            clearTimeout(to);
        };
    }, [status]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
            <div className="w-full max-w-md bg-white rounded-xl shadow p-6 text-center">
                {status === 'loading' && <p>Bitte warten…</p>}

                {status === 'ok' && (
                    <>
                        <h1 className="text-xl font-semibold mb-2">E-Mail bestätigt ✅</h1>
                        <p className="mb-2">{msg}</p>
                        <p className="mb-4">
                            Verifiziert, du wirst in {seconds} Sekunden automatisch weitergeleitet.
                        </p>
                        <a
                            href="/"
                            className="inline-block text-white bg-blue-600 px-4 py-2 rounded"
                        >
                            Jetzt weiter
                        </a>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <h1 className="text-xl font-semibold mb-2">Verifizierung fehlgeschlagen</h1>
                        <p className="mb-4">{msg}</p>
                        <a href="/" className="text-blue-600 underline">Zurück zum Login</a>
                    </>
                )}
            </div>
        </div>
    );
}
